import React from 'react';
import PropTypes from 'prop-types';

import WizardSteps from './WizardSteps';

export default function CheckoutSteps({active}) {
  return (
    <WizardSteps
      steps={CheckoutSteps.list}
      active={active}
    />
  );
}

CheckoutSteps.Steps = {
  INITIAL: 1,
  AWAITING_PAYMENT: 2,
  AWAITING_DELIVERY_DETAILS: 3,
  IN_PROGRESS: 4
};

CheckoutSteps.list = [
  'page.checkout.steps.first',
  'page.checkout.steps.second',
  'page.checkout.steps.third',
  'page.checkout.steps.fourth'
];



// WEBPACK FOOTER //
// ./components/checkout/CheckoutSteps.js